import {SmartComponent} from "smart-component-js";
import Cookies from "js-cookie";


class CompleteProfileComponent extends SmartComponent {
    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.element = element;
        this.startScreen = this.element.querySelector('.survey-start-screen');
        this.close = this.element.querySelector('.exit-btn');

        this.init();
    }

    completeProfileScreenset() {
        gigya.accounts.showScreenSet({
            containerID: "form-profile-container",
            mobileScreenSet: "",
            screenSet: "Restyle2017-ProfileUpdate",
            startScreen: "gigya-update-profile-screen-lyt",
            onAfterSubmit: () => {
                this.completeProfileMission();
                this.element.querySelector('.form-wrapper').classList.add('hidden');
            }
        });
    }


    checkStatus() {
        youserxp.ajax(`/api/1.0/loyalty/campaign/dlover2025/mission/completa-profilo/status`, {
            method: 'GET',
            auth: true,
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((data) => {
            if (data.body.canExecuteMission === true) {
                this.addStartListener();
            }

        }).catch((err) => {
            console.error(err);
        });
    }


    addFormErrorListener() {
        document.addEventListener('yxp-form-config-error-require-logged-user', () => this.showFormError());
        document.addEventListener('yxp-form-config-error-not-authorized', () => this.showFormError());
        document.addEventListener('yxp-form-config-error-date-not-valid', () => this.showFormError());
        document.addEventListener('yxp-form-config-error-already-answered', () => this.showFormError());
        document.addEventListener('yxp-form-config-error', () => this.showFormError());
        document.addEventListener('yxp-form-config-error-not-found', () => this.showFormError());
    }

    showFormError() {
        this.startScreen.remove();
        this.element.querySelector('.yxpType_FORM').classList.add('form-visible');
        this.element.classList.remove('yxpLoading');
    }

    addStartListener() {
        const startButton = this.startScreen.querySelector('.yxpType_LINK a');
        this.startScreen.classList.add('visible');
        this.element.classList.remove('yxpLoading');
        if (!startButton) {
            this.element.querySelector('.form-wrapper').classList.remove('hidden');
            return;
        }
        startButton.addEventListener('click', (e) => {
            e.preventDefault();
            this.startScreen.classList.remove('visible');
            setTimeout(() => {
                this.startScreen.remove();
                this.element.querySelector('.form-wrapper').classList.remove('hidden');
            }, 300);
        });

    }
    

    completeProfileMission() {
        this.element.classList.add('loading');
        youserxp.ajax(`/api/1.0/loyalty/campaign/dlover2025/mission/completa-profilo/completed`, {
            method: 'POST',
            auth: true,
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({})
        }).then((data) => {
            this.data = data.body;
            location.href = '/reserved/profilo-completato';

        }).catch((err) => {
            this.element.classList.remove('loading');
        });
    }


    init() {

        this.addFormErrorListener();
        this.checkStatus();
        this.completeProfileScreenset();
    }

}

export default CompleteProfileComponent;
